import React, {Component} from 'react';

class Title extends Component {
    prepareTitle() {
        return this.replaceSubject();
    }

    replaceSubject() {
        const {subject, replacements = {}} = this.props;
        let text = subject;
        Object.keys(replacements).map((search) => {
            text = text.replace(`{${search}}`, replacements[search]);
        });
        return text;
    }

    render() {
        const {className = ''} = this.props;
        const title = this.prepareTitle();
        return <span className={className}>{title}</span>;
    }
}

export default Title;
